import React from "react";
import { useTranslation } from "react-i18next";

import "./TermOverview.css";

export interface ITermOverview {
  index: number | null;
  title: string;
  machine_tool: boolean;
  technology: boolean;
  tool: boolean;
  general_information: boolean;
}

export const TermOverview: React.FC<ITermOverview> = overview => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="float-left">
        {overview.title ? (
          <h5>{overview.title}</h5>
        ) : (
          <h5>
            <i>{t("Undefined term")}</i>
          </h5>
        )}
      </div>
      <div className="float-right icons-wrapper">
        {overview.tool ? (
          <i className="fas fa-wrench" title={t("Tool")} />
        ) : null}
        {overview.machine_tool ? (
          <i className="fas fa-cogs" title={t("Machine tool")} />
        ) : null}
        {overview.technology ? (
          <i className="fas fa-industry" title={t("Technology")} />
        ) : null}
        {overview.general_information ? (
          <i className="fas fa-info" title={t("General information")} />
        ) : null}
      </div>
    </div>
  );
};
